export default __webpack_public_path__ + "static/media/scenarios_card_img_1.2f10aad0.svg";